<style lang="scss">
@import 'resources/sass/v1/abstracts/_variables';

.blog-carousel-left {
    width: 100vw;
    @media screen and (min-width: $screen-md) {
        width: 718px;
        .blog-post {
            .zoom-wrapper {
                height: 457px;
            }
            .content {
                display: flex;
                justify-content: space-between;

                h2 {
                    margin-bottom: 0 !important;
                    margin-right: 32px;
                }
                span {
                    align-self: center;
                    flex-shrink: 0;
                }
            }
        }
    }
    @media screen and (min-width: $screen-xl) {
        width: 758px;
    }
}

.blog-carousel-right {
    width: 200vw;
    display: flex;

    .blog-post {
        width: calc(50% - 24px) !important;
        float: left;
        &:first-child {
            margin-right: 48px;
        }
    }

    @media screen and (min-width: $screen-md) {
        width: 830px;
        display: block;

        .blog-post {
            width: auto !important;
            float: none;

            a {
                display: flex !important;

                .zoom-wrapper,
                .content {
                    width: 433px !important;
                    flex-shrink: 0;
                }

                .zoom-wrapper {
                    height: 280px;
                }

                .content {
                    width: 371px !important;
                    padding-left: 32px;
                }
            }
        }
    }
    @media screen and (min-width: $screen-xl) {
        width: 870px;
    }
}
</style>

<template>
    <div class="blog-post" :class="{ large: large, small: small }">
        <a class="inline-block group w-full" :href="`${blogUrl}/${blogPost.slug}`">
            <div class="relative mb-10 aspect-square overflow-hidden">
                <div class="absolute inset-0 h-full w-full transition-transform group-hover:scale-105">
                    <img class="lazyload h-full w-full object-cover object-center" :data-src="possibleBackgroundImage" :alt="blogPost.title.rendered" />
                </div>
            </div>
            <div class="content">
                <div class="flex flex-col items-start">
                    <span class="mb-4 text-primary self-start">{{ date }}</span>
                    <h3 class="text-primary text-24 mb-5 font-bold" v-html="blogPost.title.rendered"></h3>
                </div>
                <span class="text-link text-link-primary">
                    {{ translations.read_more }}
                    <svg-vue icon="arrow-right" class="text-primary ml-[.625rem] h-[.625rem] w-auto transition-transform group-hover:translate-x-1"></svg-vue>
                </span>
            </div>
        </a>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import nlBe from 'dayjs/locale/nl-be';

dayjs.locale(nlBe);

export default {
    data() {
        return {
            blogUrl: route(`${document.documentElement.lang}.blog`),
        };
    },

    props: {
        blogPost: {
            type: Object,
            required: true,
        },

        large: {
            type: Boolean,
            required: false,
        },

        small: {
            type: Boolean,
            required: false,
        },

        translations: {
            type: Object,
            required: true,
        },
    },

    computed: {
        possibleBackgroundImage() {
            if (this.blogPost.acf.image) return this.blogPost.acf.image.sizes.large;
            return '';
        },
        date() {
            return dayjs(this.blogPost.date).locale('nl-be').format('D MMMM YYYY');
        },
    },
};
</script>
